import React from 'react'

export default function PencilIcon({...props}) {
  return (
    <svg id="PencilIcon" width="24" height="24" version="1.1">
      <path d="M14.6971 5.23272L19 9.41511L20.0511 8.36396C21.2227 7.19239 21.2227 5.29289 20.0511 4.12132C18.8796 2.94975 16.9801 2.94975 15.8085 4.12132L14.6971 5.23272Z" fill="currentColor" />
      <path d="M18.2834 10.1317L14 5.92982L5.98533 13.9445C5.4727 14.4571 5.10902 15.0994 4.93319 15.8028L3.9898 19.5763C3.89825 19.9425 4.22995 20.2742 4.59614 20.1827L8.36969 19.2393C9.07302 19.0634 9.71534 18.6998 10.228 18.1871L18.2834 10.1317Z" fill="currentColor" />
    </svg>
  )
}